<template>
    <div class="productClass_info">
        <div class="mainImg">
            <img src="../../public/img/09m/product_info_header.jpg" width="100%" height="100%" alt="" srcset="">
        </div>
        <div class="nav_header"><span @click="$router.push('/')">{{$t('首页')}}</span>＞<span @click="$router.push('/productClass')">{{$t('产品分类')}}</span>＞<span @click="$router.go(-1)">{{$i18n.locale=='zh'?productClassName.name_zh:productClassName.name_en}}</span>＞<span class="info">{{productName}}</span></div>
        <div class="product_body">
            <div class="left_panel">
                <productPanel></productPanel>
                <div class="left_panel_class" style="margin-top:1.5vw;padding-bottom:1vw;">
                    <div class="title-1">{{$t('热销产品')}}</div>
                    <div class="line"></div>             
                    <div class="hot_product_box" v-for="(item, index) in hotProduct" :key="index+100">
                        <div class="hot_product">
                            <div class="hot_product_img">
                                <img :src="`${baseUrl}img/09m/热销产品/${item.img}`" width="100%" height="100%" alt="" srcset="">
                            </div>
                            <div class="line"></div>
                            <div class="btn_box">
                                <div class="text">{{$t(item.name)}}</div>
                                <div class="btn"  @click="$router.push(item.url)">{{$t('详细了解')}}</div>                                
                            </div>
                        </div>
                    </div>  
                </div>
            </div>
            <div class="right_panel">
                <productClassInfoIntroduction v-if="productInfo" :datas="productInfo" :text="text" :name="productName"></productClassInfoIntroduction>
                <div class="info_box" v-if="productInfo.tabless">
                    <div class="info_titles" v-if="productInfo.tabless">{{$t('产品简介')}}</div>
                    <br>
                    <div style="width:600px">
                        <img width="100%" :src="`${ip}/image_product/产品简介/${productInfo.tabless}`" alt="" srcset="">
                    </div>
                </div>
                <div class="info_box" v-if="classId==1">
                    <div class="info_titles">{{$t('交货时间')}}</div>
                    <br>
                    <div style="width:350px">
                        <img width="100%" src="../../public/img/09m/交货时间.jpg" alt="" srcset="">
                    </div>
                </div>
                <div class="info_box" v-if="classId==1">
                    <div class="info_titles">{{$t('定制')}}</div>
                    <br>
                    <div style="width:250px">
                        <img width="100%" src="../../public/img/09m/定制.jpg" alt="" srcset="">
                    </div>
                </div>
                <div class="info_box">
                    <div class="info_titles">{{$t('产品细节图')}}</div>
                    <img width="100%" :src="ip+'/image_product/产品细节/'+item.img" v-for="(item, index) in productDetail" :key="index" alt="" srcset="">
                </div>
            </div>
        </div>
        <foot09></foot09>
    </div>
</template>
<script>
import productClassInfoIntroduction from '../components/productClassInfoIntroduction.vue'
import productPanel from '../components/productPanel.vue'
import foot09 from '../components/foot.vue'
export default {
    components:{productClassInfoIntroduction,productPanel,foot09},
    created(){
        this.productId = this.$route.query.productId
        this.classId = this.$route.query.classId
        let _this = this
        /**获取产品细节图 */
        this.$axios({
            method:'post',
            url:this.ip + '/getDetail',
            data:this.qs.stringify({
                productId:this.productId
            }),
            headers:{'Content-Type':'application/x-www-form-urlencoded'}
        }).then((response) =>{          //这里使用了ES6的语法
            _this.productDetail = response.data.data
        }).catch((error) =>{
            console.log(error)       //请求失败返回的数据
        })
        /**获取产品类别 */
        this.$axios({
            method:'post',
            url:this.ip + '/getProductClass',
            data:this.qs.stringify({
                classId:this.classId
            }),
            headers:{'Content-Type':'application/x-www-form-urlencoded'}
        }).then((response) =>{          //这里使用了ES6的语法
            _this.productClassName = response.data.data[0]
            // console.log()
        }).catch((error) =>{
            console.log(error)       //请求失败返回的数据
        })

        /**获取产品信息 */
        this.$axios({
            method:'post',
            url:this.ip + '/getProductInfo',
            data:this.qs.stringify({
                productId:this.productId,
                classId:this.classId
            }),
            headers:{'Content-Type':'application/x-www-form-urlencoded'}
        }).then((response) =>{          //这里使用了ES6的语法
            _this.productInfo = response.data.data[0]
            console.log(response.data.data[0])
        }).catch((error) =>{
            console.log(error)       //请求失败返回的数据
        })

        /**获取产品信息 */
    },
    data() {
        return {
            productDetail:[],
            baseUrl:process.env.BASE_URL,
            productInfo:null,
            productClassName:{
                name_zh:"",
                name_en:""
            },
            hotProduct:[
                 {
                    name:"63g透气膜(PP+PE)贴条防护服",
                    img:"1.jpg",
                    id:1,
                    url:'/productClass_info?productId=1&classId=1'
                },
                {
                    name:"82g覆膜(SPP+PE)贴条防护服",
                    img:"2.jpg",
                    id:2,
                    url:'/productClass_info?productId=3&classId=1'
                },{
                    name:"一次性防护服",
                    img:"3.jpg",
                    id:3,
                    url:'/productClass_info?productId=8&classId=1'
                }
            ]
        }
    },
    watch:{
        $route(){
            this.$router.go(0)
        }
    },
    computed:{
        productName(){
            if(this.productInfo){

                return this.$i18n.locale=='zh'? this.productInfo.name_zh:this.productInfo.name_en
            }else{
                return ''
            }
        },
        text(){
           if(this.productInfo){

                return this.$i18n.locale=='zh'? this.productInfo.lead_zh:this.productInfo.lead_en
            }else{
                return ''
            } 
        },
    }
}
</script>
<style lang="less" scoped>
.productClass_info{
    height: fit-content;
    width: 100vw;
    @height:35vw;
    @hot_product_box_width:16.5vw;
    .nav_header{
        width: calc(62.1vw - 50px);
        height: fit-content;
        background-color: #F5F5F5;
        margin: 2vw auto;
        font-family: 'YHBD';
        color: #444444;
        padding: 15px 25px;
        span{
            cursor: pointer;
            font-family: 'YHBD';
        }
        .info{
            color:#017CA8;
        }
    }
    .info_box{
        width: calc(100% - 30px);
        padding-left: 30px;
        height: fit-content;
        margin-top: 1.5vw;
        .blue_txt{
            font-size: 0.9rem;
            color: #017CA8;
            font-family: 'YH';
            margin-top: 0.9rem;
            
            span{
                margin-left: 20px;
                font-size: 0.9rem;
                color: #777777;
                font-family: 'YH';            
            }
        }
        .info_titles{
            color: #4C4C4C;
            font-family: "YHBD";
            position: relative;
            // background-color: red;
            &::after {
                content: '';
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background-color: #007CA9;
                left: 0;
                position: absolute;
                top: 50%;
                transform: translate(-250%,-50%);
            }
        }
    }
    .hot_product_box{
        width: @hot_product_box_width;
        height: @hot_product_box_width*1.56;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 1vw 0;
        .hot_product{
            width: 88%;
            height: 100%;
            background-color: #ffffff;
            .hot_product_img{
                width: 100%;
                height: @hot_product_box_width*1.17;
                background-color: yellow;
            }
            .line{
                width: 100%;
                height: 2px;
                background-image: linear-gradient(45deg,#009D40,#007CA9);
                margin: 0 auto;
                transform: scaleY(0.3);
            }
            .btn_box{
                width: 100%;
                height: @hot_product_box_width*1.56 - @hot_product_box_width*1.17 - 1.5px ;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
                // background-color: red;
            }
            .btn{
                // height: 30%;
                width: 60%;
                display: flex;
                color: #F7F7F7;
                font-size: 0.8vw;
                cursor: pointer;
                padding: 6px 0px;
                font-family: "YHBD";
                align-items: center;
                justify-content: center;
                background-image: linear-gradient(90deg,#009D40,#007CA9);
            }
            .text{
                color: #565656;
                font-weight: bold;
                font-size: @hot_product_box_width/20;
                // margin-top: 20px;
                text-align: center;
                font-family: "pfb";
                // background-color: gray;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100%;
            }
        }
    }
    .line{
        width: 88%;
        height: 1px;
        background-color: #444444;
        margin: 0 auto;
    }
    .title-1{
        color: #444444;
        font-family: 'YHBD';
        font-weight: bold;
        font-size: 1.3vw;
        letter-spacing: 0.1vw;
        width: fit-content;
        // line-height: 4vw;
        height: fit-content;
        margin-top: 1vw;
        margin-bottom: 1vw;
        margin-left: 10%;
    }
    .mainImg{
        width: 100vw;
        height: @height;
        overflow: hidden;
        position: relative;
        // background-color: rgb(177, 64, 139);
        // margin-bottom: 3vw;
    }
    .left_panel_class_info{
        color: #444444;
        font-size: 1vw;
        line-height: 2.5vw;
        width: fit-content;
        margin-left: 10%;
        font-family: 'pf';
        font-weight: lighter;
    }
    .product_body{
        width: 62.1vw;
        min-height: 30px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        .left_panel{
            width: 16.5vw;
            min-height: 10vw;
            .left_panel_class{
                background-color: #F5F5F5;
                font-size: 1vw;
                min-height: 10vw;
                width: 100%;
                padding-top: 1px;
            }
        }

        .right_panel{
            width: 44.1vw;
            min-height: 10vw;     
        }
    }
    
    
}
</style>
<i18n>
{
  "en": {
       "一次性防护服":"Disposable Coverall",
       "实验服":"Disposable Lab Coat",
       "隔离衣":"Disposable Isolation Gown",
       "一次性防护口罩":"Disposable Face Mask",
       "透气膜头套":"Microporous Hood",
       "胡须套":"Beard Cover",
       "条帽":"Bouffant Cap",    
       "袖套":"Microporous Sleeve Cover",       
       "靴套":"Disposable Boot Cover",       
       "鞋套":"Shoe Cover",
       "PE塑料手套":"Plastic Gloves"
  },
  "zh": {
       "一次性防护服":"一次性防护服",
       "实验服":"实验服",
       "隔离衣":"隔离衣",
       "一次性防护口罩":"一次性防护口罩",
       "透气膜头套":"透气膜头套",
       "胡须套":"胡须套",
       "条帽":"条帽",    
       "袖套":"袖套",       
       "靴套":"靴套",       
       "鞋套":"鞋套",
       "PE塑料手套":"PE塑料手套"
    }
}
</i18n>